import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination
} from '@mui/material';
import { fetchAllTransactions } from '../api';

const TRANSACTIONS_PER_PAGE = 10;

export default function TransactionsPage() {
  const [currentPage, setCurrentPage] = useState(1);
  const [allTransactions, setAllTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch all transactions (no filters)
  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const all = await fetchAllTransactions();
      setAllTransactions(all);
    } catch (error) {
      // Optionally handle error
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  // Pagination logic (frontend)
  const totalPages = Math.ceil(allTransactions.length / TRANSACTIONS_PER_PAGE);
  const paginatedTransactions = allTransactions.slice(
    (currentPage - 1) * TRANSACTIONS_PER_PAGE,
    currentPage * TRANSACTIONS_PER_PAGE
  );

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <Layout>
      <PageHeader title="Transaction History" subtitle="All your transactions in one place." />
      <Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: 'lg', mx: 'auto' }}>
        <Card variant="outlined" sx={{ mb: 4 }}>
          <CardContent>
            {loading ? (
              <Typography align="center" color="text.secondary">
                Loading transactions...
              </Typography>
            ) : (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Cash in Hand</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedTransactions.map((tx) => (
                      <TableRow key={tx.id} hover>
                        <TableCell>
                          {format(new Date(tx.date), 'hh:mm:ss aa (dd-MMM-yyyy)')}
                        </TableCell>
                        <TableCell sx={{ textTransform: 'capitalize' }}>
                          {tx.transaction_type}
                        </TableCell>
                        <TableCell>৳{tx.amount}</TableCell>
                        <TableCell>৳{tx.cash_in_hand}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            {/* Pagination Controls */}
            <Box display="flex" justifyContent="center" mt={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Layout>
  );
}
